import { Component, DestroyRef, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { rxResourceFixed } from '@zayan-erp/shared';
import { FormControl, ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { InputFieldComponent, CurrencyInputFieldComponent } from '@zayan-erp/shared';
import { ToggleSwitchModule } from '@openng/optimus-ui/toggleswitch';
import { SalesService } from '../../../../services/sales.service';
import { LinkedSalesAgentInfo } from '../../../../models/linked-sales-agent.models';
import { map, of, tap } from 'rxjs';

@Component({
  selector: 'lib-linked-sales-agents-form',
  imports: [InputFieldComponent, CurrencyInputFieldComponent, FormsModule, ReactiveFormsModule, ToggleSwitchModule],
  templateUrl: './linked-sales-agents-form.component.html'
})
export class LinkedSalesAgentsFormComponent {
  #destroyRef = inject(DestroyRef);
  #salesService = inject(SalesService);

  salesAgentId = input<string | null>(null);
  dealId = input<string | null>(null);
  reloadTrigger = output<void>();

  saleAgentForm = new FormGroup({
    allowCommissionOnBase: new FormControl<boolean | null>(null),
    allowCommissionOnOption: new FormControl<boolean | null>(null),
    baseCommissionPercentage: new FormControl<number | null>(null, [Validators.min(0)]),
    baseCommissionAmount: new FormControl<number | null>(null, [Validators.min(0)]),
    optionCommissionPercentage: new FormControl<number | null>(null, [Validators.min(0)]),
    optionCommissionAmount: new FormControl<number | null>(null, [Validators.min(0)]),
    notes: new FormControl<string | null>(null)
  });
  linkedSalesAgentResource = rxResourceFixed({
    params: () => ({ dealId: this.dealId(), salesAgentId: this.salesAgentId() }),
    defaultValue: null,
    stream: ({ params }) => {
      if (params.dealId && params.salesAgentId) {
        return this.#salesService.getLinkedSalesAgent(params.dealId, params.salesAgentId).pipe(
          tap(linkedSalesAgent => {
            this.editForm(linkedSalesAgent);
          })
        );
      }
      return of(null);
    }
  });
  editForm(linkedSalesAgent: LinkedSalesAgentInfo): void {
    this.saleAgentForm.patchValue({
      allowCommissionOnBase: linkedSalesAgent.allowCommissionOnBase,
      allowCommissionOnOption: linkedSalesAgent.allowCommissionOnOption,
      baseCommissionPercentage: linkedSalesAgent.baseCommissionPercentage,
      baseCommissionAmount: linkedSalesAgent.baseCommissionAmount,
      optionCommissionPercentage: linkedSalesAgent.optionCommissionPercentage,
      optionCommissionAmount: linkedSalesAgent.optionCommissionAmount,
      notes: linkedSalesAgent.notes
    });
  }

  onSubmit(): void {
    console.log('onSubmit', this.saleAgentForm.value);
    if (this.saleAgentForm.valid) {
      this.#salesService
        .updateLinkedSalesAgent(
          this.dealId() ?? '',
          this.salesAgentId() ?? '',
          this.saleAgentForm.value as LinkedSalesAgentInfo
        )
        .pipe(takeUntilDestroyed(this.#destroyRef))
        .subscribe(() => {
          this.saleAgentForm.reset();
          this.reloadTrigger.emit();
        });
    }
  }
}
